import _ from 'lodash';
import {
  formatProjectsToStore,
  formatProviderAreasToStore,
  formatProviderTeamsToStore
} from './wizard.state.formatters';
import { getAreas, getTeams } from 'common/services/pm.azure_boards.service';
export const RESET_WIZARD_STATE = 'RESET_WIZAR_STATE';
export const TOGGLE_ACTION_LOADING = 'TOGGLE_ACTION_LOADING';

export const ON_CLICK_PROJECT = 'ON_CLICK_PROJECT';
export const ON_CLICK_TEAM = 'ON_CLICK_TEAM';

export const OPEN_WIZARD = 'OPEN_WIZARD';
export const CLOSE_WIZARD = 'CLOSE_WIZARD';
export const ON_CLOSE_TEAM_WIZARD = 'ON_CLOSE_TEAM_WIZARD';
export const ON_CLOSE_AREAS_WIZARD = 'ON_CLOSE_AREAS_WIZARD';

export const FETCH_PROJECT_TEAMS = 'FETCH_PROJECT_TEAMS';
export const FETCH_PROJECT_AREAS = 'FETCH_PROJECT_AREAS';
export const FETCH_TEAM_AREAS = 'FETCH_TEAM_AREAS';

export const SET_PROJECTS = 'SET_PROJECTS';
export const TOGGLE_AREA_CHECKBOX = 'TOGGLE_AREA_CHECKBOX';
export const TOGGLE_AREA_CHECKBOX_ALL = 'TOGGLE_AREA_CHECKBOX_ALL';
export const ON_FINISH_WIZARD_SELECTION = 'ON_FINISH_WIZARD_SELECTION';
export const ON_CLICK_EDIT_IDX = 'ON_CLICK_EDIT_IDX';
export const ON_DELETE_SELECTED_VALUE_BY_IDX =
  'ON_DELETE_SELECTED_VALUE_BY_IDX';
export const ON_EDIT_SELECTED_VALUE = 'ON_EDIT_SELECTED_VALUE';

export const closeWizard = () => dispatch =>
  dispatch({
    type: CLOSE_WIZARD
  });

export const openWizard = () => dispatch =>
  dispatch({
    type: OPEN_WIZARD
  });

export const onCloseTeamsWizard = () => dispatch =>
  dispatch({ type: ON_CLOSE_TEAM_WIZARD });

export const onCloseAreasWizard = () => dispatch =>
  dispatch({ type: ON_CLOSE_AREAS_WIZARD });

const toggleActionLoading = (actionName, isLoading) => ({
  type: TOGGLE_ACTION_LOADING,
  payload: [actionName, isLoading]
});

export const setProjects = projects => dispatch =>
  dispatch({ type: SET_PROJECTS, payload: formatProjectsToStore(projects) });

export const onClickProject = project => async dispatch =>
  dispatch({
    type: ON_CLICK_PROJECT,
    payload: project
  });

export const onClickTeam = team => async dispatch =>
  dispatch({
    type: ON_CLICK_TEAM,
    payload: team
  });

export const fetchProjectTeams = project => async dispatch => {
  try {
    dispatch(toggleActionLoading(FETCH_PROJECT_TEAMS, true));
    const projectTeams = await getTeams({ projectId: project.id });
    dispatch({
      type: FETCH_PROJECT_TEAMS,
      payload: formatProviderTeamsToStore(projectTeams)
    });
  } catch (e) {
  } finally {
    dispatch(toggleActionLoading(FETCH_PROJECT_TEAMS, false));
  }
};

export const fetchProjectAreas =
  ({ state, keyword = '' }) =>
  async dispatch => {
    try {
      dispatch(toggleActionLoading(FETCH_PROJECT_AREAS, true));
      const { selectedProject, teamAreas = [], selectedAreas = [] } = state;
      const teamAreasIds = teamAreas.map(area => area.id);
      const selectedAreasIds = selectedAreas.map(area => area.id);

      const projectAreas = await getAreas({
        projectId: selectedProject.id,
        ...(keyword && { keyword })
      });
      const formattedAreas = formatProviderAreasToStore(projectAreas);
      const orderedAreas = _.orderBy(
        formattedAreas,
        [
          area => teamAreasIds.includes(area.id),
          area => selectedAreasIds.includes(area.id)
        ],
        ['desc', 'desc']
      );
      dispatch({
        type: FETCH_PROJECT_AREAS,
        payload: orderedAreas
      });
    } catch (e) {
    } finally {
      dispatch(toggleActionLoading(FETCH_PROJECT_AREAS, false));
    }
  };

export const fetchTeamsAreas =
  ({ state, keyword = '' }) =>
  async dispatch => {
    try {
      const { selectedProject, selectedTeam } = state;
      dispatch(toggleActionLoading(FETCH_TEAM_AREAS, true));

      const teamAreas = await getAreas({
        teamId: selectedTeam.id,
        projectId: selectedProject.id
      });
      const formattedAreas = formatProviderAreasToStore(teamAreas);
      dispatch({
        type: FETCH_TEAM_AREAS,
        payload: formattedAreas
      });
    } catch (e) {
    } finally {
      dispatch(toggleActionLoading(FETCH_TEAM_AREAS, false));
    }
  };

export const toggleAreaCheckbox = area => async dispatch =>
  dispatch({
    type: TOGGLE_AREA_CHECKBOX,
    payload: area
  });

export const toggleAreaCheckboxAll = isSelectAll => async dispatch =>
  dispatch({
    type: TOGGLE_AREA_CHECKBOX_ALL,
    payload: isSelectAll
  });

export const onFinishWizardSelection = wizardState => dispatch => {
  const { selectedProject, selectedTeam, teamAreas, selectedAreas } =
    wizardState;

  const payload = {
    project: selectedProject,
    team: selectedTeam,
    areas: _.uniqBy([...teamAreas, ...selectedAreas], 'id')
  };
  dispatch({
    type: ON_FINISH_WIZARD_SELECTION,
    payload
  });
};

export const onDeleteSelectedValueByIdx = idx => dispatch =>
  dispatch({
    type: ON_DELETE_SELECTED_VALUE_BY_IDX,
    payload: idx
  });

export const onClickEditIdx = idx => dispatch =>
  dispatch({
    type: ON_CLICK_EDIT_IDX,
    payload: idx
  });

export const onEditSelectedValue = selectedValue => dispatch => {
  dispatch({
    type: ON_EDIT_SELECTED_VALUE,
    payload: selectedValue
  });
};
